import { TextArea as NbTextArea } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

import type { _TextAreaComponentType } from './types';

export const TextArea: _TextAreaComponentType = NbTextArea;

export default addWithConfig(TextArea);
